export enum ManageMode {
  CREATE = 'Create New ',
  UPDATE = 'Update ',
  EXPORT = 'Export ',
  IMPORT = 'Import ',
  VIEW = 'View ',
  DOWNLOAD = 'Download ',
  TITLE_DOWNLOAD = 'Title Download',
  CLONE = 'Clone ',
  PROFILE = 'Profile ',
  QUICK_UPDATE = 'Quick Update ',
  ASSIGN = 'Assign',
  INVOICE = 'Invoice'
}
